//
//
//
//
//
//
//

import { _slug } from "./helpers"

export default {
  name: 'PanelFilterGroup',
  props: ['title'],
  data: function() {
    return {
      isOpen: false,
      titleId: _slug(this.title),
    }
  },
}



// WEBPACK FOOTER //
// ./scripts/vue/PanelFilterGroup.vue